import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import P1MedicalRequestCancel from './P1MedicalRequestCancel';
import { Document } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	item: Document;
	onSuccess: () => void;
}

const P1MedicalRequestCancelModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.p1PMedicalRequestCancel.modalTitle'>
			<P1MedicalRequestCancel item={props.item} onSuccess={props.onSuccess} />
		</BaseModal>
	);
};

export default P1MedicalRequestCancelModal;
